import i18n from '@/utils/i18n';
import React from 'react';
import { ActionSheet } from './action-sheet';
import {
  AllowedShortcuts,
  KeyboardScope,
} from '@/platform/shortcuts/operator-shortcuts';
import { formatSummaryDate } from '@/utils/date';
import { Moment } from 'moment';
import { useKeyboardShortcuts } from '@platform/shortcuts/hooks/use-keyboard-shortcuts';

export interface Props {
  fulfillmentDate: Moment | string;
  isVisible: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const FallbackConfirmationActionSheet: React.FC<Props> = ({
  fulfillmentDate,
  isVisible,
  onClose,
  onContinue,
}) => {
  useKeyboardShortcuts(
    AllowedShortcuts.PlaceOrder,
    onContinue,
    [],
    {},
    true,
    KeyboardScope.ACTION_SHEET,
  );

  return (
    <ActionSheet
      actions={[
        i18n.t('fallback_confirmation.continue'),
        i18n.t('fallback_confirmation.back'),
      ]}
      isFocusableForKeyboardShortcuts
      isVisible={isVisible}
      message={i18n.t('fallback_confirmation.message', {
        date: formatSummaryDate(fulfillmentDate),
      })}
      onAction={(_, index) => {
        if (index === 0) {
          onContinue();
        } else {
          onClose();
        }
      }}
      onClose={onClose}
      title={i18n.t('fallback_confirmation.title')}
    />
  );
};
